declare const jQuery: any;
const $ = jQuery;

// $el - JQuery|HTMLElement|selector
export function getTimeCssPropertyInMilliseconds($el, cssProperty: string): number|undefined
{
	$el = $($el);
	const cssValue: string = $el.css(cssProperty);
	if (!cssValue)
	{
		return undefined;
	}
	const numValue: number = parseFloat(cssValue);
	if (isNaN(numValue))
	{
		return undefined;
	}
	if (cssValue.match(/ms$/))
	{
		return numValue;
	}
	if (cssValue.match(/s$/))
	{
		return numValue * 1000;
	}
	return undefined;
}

export function getCssTransitionTime($el): number
{
	const duration: number = getTimeCssPropertyInMilliseconds($el, "transition-duration") || 0;
	const delay: number = getTimeCssPropertyInMilliseconds($el, "transition-delay") || 0;
	return duration + delay;
}

if (!window["iw"])
{
	window["iw"] = {};
}

if (!window["iw"].utils)
{
	window["iw"].utils = {};
}

window["iw"].utils.getTimeCssPropertyInMilliseconds = getTimeCssPropertyInMilliseconds;
window["iw"].utils.getCssTransitionTime = getCssTransitionTime;
